import angular from "angular";

import GatewayModuleRouting from "./gateway.module.routing";

export default angular
    .module("vt-gateway", [])
    .config(GatewayModuleRouting);
